var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "product-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "product-card",
          class: {
            "product-card--no-border": _vm.hideCard,
            "product-card--no-thumbnails": !_vm.hasOutfitContext
          }
        },
        [
          _c(
            "section",
            { staticClass: "interaction-buttons-container" },
            [
              _c("swap-item-button", {
                attrs: { iconSize: "25px" },
                on: { click: _vm.setSwapProduct }
              }),
              _vm._v(" "),
              _vm._t("interaction-buttons")
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "current-product-image-container" },
            [
              _c("slide-show", {
                attrs: { images: _vm.slideShowImages, navigateTo: 0 },
                on: {
                  "image-changed": _vm.imageChanged,
                  "image-clicked": _vm.imageClicked
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "current-product-hearth-button" },
            [
              !_vm.isProductOOS
                ? _c("save-product", {
                    attrs: {
                      product: _vm.currentProduct,
                      outfitId: _vm.outfit && _vm.outfit.outfit_id
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("section", { staticClass: "current-product-container" }, [
            _c("div", { staticClass: "current-product-title-container" }, [
              _c("h3", { staticClass: "current-product-title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.currentProduct.product_title) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "line-clamp",
                      rawName: "v-line-clamp",
                      value: _vm.descriptionLineClamp,
                      expression: "descriptionLineClamp"
                    }
                  ],
                  staticClass: "current-product-description",
                  on: { click: _vm.toggleDescription }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.currentProduct.product_description) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "view-on-brand",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.openExternalURL(
                        _vm.currentProduct.product_buy_url,
                        $event
                      )
                    }
                  }
                },
                [_vm._v("View product via brand")]
              )
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "current-product-price" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("currency")(_vm.currentProduct.product_price)) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.hasOutfitContext
            ? _c(
                "section",
                {
                  staticClass: "outfit-products-container",
                  class: {
                    "outfit-products-container--five-products":
                      _vm.hasOutfitContext && _vm.outfit.products.length > 4
                  }
                },
                _vm._l(_vm.outfit.products, function(product) {
                  return _c(
                    "div",
                    {
                      key: product.product_id,
                      staticClass: "outfit-product",
                      class: {
                        "outfit-product--current":
                          _vm.currentProduct.product_id === product.product_id
                      },
                      on: {
                        click: function() {
                          return _vm.outfitImageClicked(product.product_id)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "outfit-product-image",
                        attrs: {
                          src: product.product_image_url,
                          alt: product.product_title
                        }
                      })
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "current-product-options-container" },
        [
          _c("color-size-selector", {
            ref: "colorSizeSelector",
            attrs: {
              colors: _vm.currentProduct.product_colors,
              sizes: _vm.sortedSizes,
              selectedColorId: _vm.currentProduct.product_option_value_id_color,
              selectedSizeId: _vm.currentProduct.product_option_value_id_size,
              isPristine: _vm.currentProduct.isPristine
            },
            on: {
              "color-changed": function(event) {
                return _vm.productChanged(
                  _vm.setOption("color", _vm.currentProduct, event)
                )
              },
              "size-changed": function(event) {
                return _vm.productChanged(
                  _vm.setOption("size", _vm.currentProduct, event)
                )
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "footer-buttons-container" },
        [
          _vm.hasOutfitContext
            ? _c("share-outfit", { attrs: { outfit: _vm.outfit } })
            : _c("share-product", {
                attrs: {
                  id: _vm.currentProduct.product_id,
                  url: _vm.slideShowImages[0] && _vm.slideShowImages[0].uri
                }
              }),
          _vm._v(" "),
          _vm.isVariantOOS || _vm.isProductOOS
            ? [
                _vm.hasOutfitContext
                  ? _c("swap-item-button", {
                      attrs: {
                        classes: "footer-button footer-button--pink btn-16",
                        text: "SWAP",
                        icon: "white"
                      },
                      on: {
                        click: function() {
                          return _vm.setSwapProduct(true)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "footer-button footer-button--dark-gray btn-16 pd-30",
                    attrs: { disabled: true }
                  },
                  [_vm._v("\n                OUT OF STOCK\n            ")]
                )
              ]
            : [
                _vm.hasOutfitContext
                  ? _c("purchase-outfit-button", {
                      staticClass: "footer-button",
                      attrs: { outfit: _vm.outfit },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.purchaseOutfit.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showFooterSaveButton
                  ? _c("save-product", {
                      attrs: {
                        saveProductClassList: "footer-button",
                        child: "save-button-footer",
                        product: _vm.currentProduct,
                        outfitId: _vm.outfit && _vm.outfit.outfit_id
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "footer-button footer-button--pink",
                    class: {
                      "footer-button--only":
                        !_vm.hasOutfitContext && !_vm.showFooterSaveButton
                    },
                    on: { click: _vm.addProductToCart }
                  },
                  [_vm._v("\n                Add item to Cart\n            ")]
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showSwapProduct
            ? _c("swap-item", {
                attrs: {
                  product: _vm.currentProduct,
                  showSizes: _vm.showSwapProductSizes,
                  swapCb: _vm.hasOutfitContext ? "" : _vm.swapProduct
                },
                on: {
                  close: function() {
                    return (this$1.showSwapProduct = false)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73385c91", { render: render, staticRenderFns: staticRenderFns })
  }
}